<template>
    <el-dialog title="Nueva Orden de Pago"
        width="45%"
        :visible="showDialog"
        @close="close"
        @open="loadDataClient"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
        <div class="row" v-loading="loading_payment"
            element-loading-text="Consultando monto a pagar..."
        >
            <div class="col-12">
                <div class="form-group"
                    :class="{ 'has-danger': errors.client_id }"
                >
                    <label class="control-label">
                        Cliente
                    </label>
                    <el-select placeholder="Seleccione un cliente"
                        v-model="form.client_id"
                        filterable
                        remote
                        :remote-method="searchRemoteClients"
                        :loading="loading_search"
                        loading-text="Bucando clientes..."
                        @change="getAmount"
                        :disabled="recordId"
                    >
                        <el-option v-for="(client, index) in clients"
                            :key="index"
                            :value="client.id"
                            :label="client.name"
                        ></el-option>
                    </el-select>
                    <small class="form-control-feedback" v-if="errors.client_id"
                        v-text="errors.client_id[0]"
                    ></small>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group"
                    :class="{ 'has-danger': errors.date_of_due }"
                >
                    <label class="control-label">
                        Fecha de gracia
                    </label>
                    <el-date-picker v-model="form.date_of_due"
                        type="date"
                        placeholder="Fecha de gracia"
                        format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                    <small class="form-control-feedback" v-if="errors.date_of_due"
                        v-text="errors.date_of_due[0]"
                    ></small>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group"
                    :class="{ 'has-danger': errors.date_of_payment }"
                >
                    <label class="control-label">
                        Fecha de pago
                    </label>
                    <el-date-picker v-model="form.date_of_payment"
                        type="date"
                        placeholder="Fecha de gracia"
                        format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                    <small class="form-control-feedback" v-if="errors.date_of_payment"
                        v-text="errors.date_of_payment[0]"
                    ></small>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group"
                    :class="{ 'has-danger': errors.payment_method_type_id }"
                >
                    <label class="control-label">
                        Método de pago
                    </label>
                    <el-select v-model="form.payment_method_type_id" placeholder="Seleccione un metodo"
                        @change="changePaymentMethodType"
                    >
                        <el-option v-for="(option, index) in payment_method_types"
                            :key="index"
                            :value="option.id"
                            :label="option.description"
                        ></el-option>
                    </el-select>
                    <small class="form-control-feedback" v-if="errors.payment_method_type_id"
                        v-text="errors.payment_method_type_id[0]"
                    ></small>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group"
                    :class="{ 'has-danger': errors.card_brand_id }"
                >
                    <label class="control-label">
                        Tarjeta
                    </label>
                    <el-select v-model="form.card_brand_id" placeholder="Seleccione"
                        :disabled="!form.has_card"
                    >
                        <el-option v-for="(option, index) in card_brands"
                            :key="index"
                            :value="option.id"
                            :label="option.description"
                        ></el-option>
                    </el-select>
                    <small class="form-control-feedback" v-if="errors.card_brand_id"
                        v-text="errors.card_brand_id[0]"
                    ></small>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="form-group"
                    :class="{ 'has-danger': errors.payment }"
                >
                    <label class="control-label">
                        Monto
                    </label>
                    <el-input v-model="form.payment" placeholder="Ingresar monto">
                        <template slot="prepend">S/</template>
                    </el-input>
                    <small class="form-control-feedback" v-if="errors.payment"
                        v-text="errors.payment[0]"
                    ></small>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group"
                    :class="{ 'has-danger': errors.reference }"
                >
                    <label class="control-label">
                        Concepto
                    </label>
                    <el-input v-model="form.reference" placeholder="Ingresar concepto"></el-input>
                    <small class="form-control-feedback" v-if="errors.reference"
                        v-text="errors.reference[0]"
                    ></small>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary"
                :loading="submit_register"
                :disabled="submit_register_and_notify"
                @click="submitRegister"
            >
                Crear orden
            </el-button>
            <el-button type="primary"
                :loading="submit_register_and_notify"
                :disabled="submit_register"
                @click="submitRegisterAndNotify"
            >
                Crear y notificar orden
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
    import moment from 'moment'

    export default {
        props: {
            showDialog: {
                type: Boolean,
                default: false
            },
            recordId: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                loading_search: false,
                loading_payment: false,
                submit_register: false,
                submit_register_and_notify: false,
                clients: [],
                form: {},
                errors: {},
                payment_method_types: [],
                card_brands: [],
                timer: null,
            }
        },
        async created() {
            this.initForm()
            await this.loadDataForm()
            await this.getClients()
        },
        methods: {
            initForm() {
                this.form = {
                    client_id: null,
                    date_of_due: moment().format('YYYY-MM-DD'),
                    date_of_payment: moment().format('YYYY-MM-DD'),
                    payment_method_type_id: null,
                    card_brand_id: null,
                    reference: null,
                    payment: null,
                    has_card: false,
                    file: null, // file y temp_path no se usan en el formulario, pero se mantienen para compatibilidad con el backend
                    temp_path: null,
                }
            },

            close() {
                this.initForm()
                this.$emit('update:showDialog', false)
            },

            async loadDataForm() {
                const { data } = await this.$http.get('/client_payments/tables')
                this.payment_method_types = data.payment_method_types
                this.card_brands = data.card_brands
            },

            changePaymentMethodType() {
                const method_type = this.payment_method_types.find(m => m.id === this.form.payment_method_type_id)
                if (method_type) {
                    const has_card = Boolean(method_type.has_card)
                    this.form.has_card = has_card
                    if (!has_card) {
                        this.form.card_brand_id = null
                    }
                }
            },

            searchRemoteClients(input) {
                this.loading_search = true
                clearTimeout(this.timer)
                this.timer = setTimeout(async () => {
                    await this.getClients(input)
                    this.loading_search = false
                }, 100)
            },

            async getClients(param = null) {
                try {
                    const { data } = await this.$http.post('/client-payments/clients', {
                        param: param
                    })
                    if (data.success) {
                        this.clients = data.data
                    }
                } catch (error) {
                    this.$message.error(error.response.data.message)
                }
            },

            async getAmount() {
                try {
                    this.loading_payment = true
                    const { data } = await this.$http.post('/client-payments/amount', {
                        client_id: this.form.client_id
                    })
                    if (data.success) {
                        this.form.payment = data.price
                    }
                } catch (error) {
                    this.$message.error(error.response.data.message)
                } finally {
                    this.loading_payment = false
                }
            },

            validForm() {
                if (this.form.has_card && !this.form.card_brand_id) {
                    this.$message.error('Elija una tarjeta.')
                    return false
                }
                return true
            },

            async storePayment(trigger_emit = false) {
                const { data } = await this.$http.post('/client_payments', this.form)
                if (data.success) {
                    this.$message.success(data.message)
                    if (trigger_emit) {
                        this.$emit('registered')
                    }
                    this.close()
                } else {
                    this.$message.error(data.message)
                }
                return data
            },

            async submitRegister() {
                try {
                    if (!this.validForm()) return
                    this.submit_register = true
                    await this.storePayment(true)
                } catch (error) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        if (error.response) {
                            const message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                } finally {
                    this.submit_register = false
                }
            },

            async submitRegisterAndNotify() {
                try {
                    if (!this.validForm()) return
                    this.submit_register_and_notify = true
                    const data = await this.storePayment()
                    if (data.success) {
                        await this.sendNotification(data.data)
                        this.$emit('registered')
                    }
                } catch (error) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        if (error.response) {
                            const message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                } finally {
                    this.submit_register_and_notify = false
                }
            },

            async sendNotification(paramData) {
                const { data } = await this.$http.post('/client-payments/sendNotification', paramData)
                if (data.success) {
                    this.$message.success(data.message)
                } else {
                    this.$message.error(data.message)
                }
            },

            async loadDataClient() {
                if (this.recordId) {
                    this.form.client_id = this.recordId
                    try {
                        const { data } = await this.$http.post('/client-payments/clients', {
                            id: this.recordId
                        })
                        if (data.success) {
                            this.clients = data.data
                            await this.getAmount()
                        }
                    } catch (error) {
                        this.$message.error(error.response.data.message)
                    }
                    
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/payments/components/form.vue